/** @jsxImportSource @emotion/react */

import { useContext } from "react";
import { CategoryContext } from "../../contexts/CategoryContext";
import Box from "../Box/Box";
import { icons } from "../../theme/icons";
import { theme } from "../../theme/theme";
import useBreakpoint from "../../hooks/useBreakpoint";

type Props = {
  slideId: number;
};

const Stepper = ({ slideId }: Props) => {
  const { category, setCategory, mainTopic } = useContext(CategoryContext);
  const {isMobile} = useBreakpoint();

  const { BackIcon } = icons.general;

  return (
    <Box
      display="flex"
      //justifyContent="flex-end"
      // position="absolute"
      // right={0}
      // paddingRight={20}
    >
      <BackIcon
        cursor="pointer"
        style={{
         
        }}
        onClick={() => {
          if (mainTopic === "reduceMaterials") {
            if (slideId === 0) setCategory("UHPCs");
            if (slideId === 1) setCategory("ProductsUsingLessMaterial");
            if (slideId === 2) setCategory("Special3DConcretePrinting");
          }
          if (mainTopic === "reuseMaterials") {
            if (slideId === 0) setCategory("ConcreteRecycledAggregates");
            if (slideId === 1) setCategory("CircularProducts");
            if (slideId === 2) setCategory("ConcreteModulesConcrete");
          }
          if (mainTopic === "reuseCO2") {
            if (slideId === 0) setCategory("LengfurtCCU");
            if (slideId === 1) setCategory("DecarbonisedProducts");
            if (slideId === 2) setCategory("BrevikCCS");
          }
          if (mainTopic === "reduceCO2") {
            if (slideId === 0)
              setCategory("SubstitutingClinkerWithCalcineClay");
            if (slideId === 1) setCategory("CarbonReducedProducts");
            if (slideId === 2) setCategory("SubstitutingClinkerWithFlyAsh");
          }
        }}
      />

      <Box display="flex" justifyContent="center" alignItems="center">
        {[0, 1, 2].map((el) => {
          return (
            <div
              css={{
                width: isMobile ? 40: 130,
                height: isMobile ? 4: 6,
                backgroundColor: theme.colors.primary,
                marginRight: 10,
                marginLeft: 10,
                opacity: el === slideId ? 1 : 0.3,
              }}
            ></div>
          );
        })}
      </Box>

      <BackIcon
        cursor="pointer"
        style={{ rotate: "180deg" }}
        onClick={() => {
          if (mainTopic === "reduceMaterials") {
            if (slideId === 0) setCategory("Special3DConcretePrinting");
            if (slideId === 1) setCategory("UHPCs");
            if (slideId === 2) setCategory("ProductsUsingLessMaterial");
          }

          if (mainTopic === "reuseMaterials") {
            if (slideId === 0) setCategory("ConcreteModulesConcrete");
            if (slideId === 1) setCategory("ConcreteRecycledAggregates");
            if (slideId === 2) setCategory("CircularProducts");
          }

          if (mainTopic === "reuseCO2") {
            if (slideId === 0) setCategory("BrevikCCS");
            if (slideId === 1) setCategory("LengfurtCCU");
            if (slideId === 2) setCategory("DecarbonisedProducts");
          }

          if (mainTopic === "reduceCO2") {
            if (slideId === 0) setCategory("SubstitutingClinkerWithFlyAsh");
            if (slideId === 1)
              setCategory("SubstitutingClinkerWithCalcineClay");
            if (slideId === 2) setCategory("CarbonReducedProducts");
          }
        }}
      />
    </Box>
  );
};

export default Stepper;
